import { LineItemDesciptionType } from 'common/src/types/enums/LineItemType.enum';
import { ILineItem } from 'common/src/types/interfaces';

/**
 * Filters out allocation-related line items from a collection of line items.
 *
 * @param { Partial<ILineItem>[] } lineItems - An array of line items to filter
 * @returns A new array containing only non-allocation line items
 *
 * @remarks
 * - An item is considered an allocation item if it has BOTH negative cost AND reversed allocation description
 * - All reversed allocation items are filtered out regardless of cost
 * - The function returns a new array and does not mutate the original input
 */
export const filterReverseAllocationLineItems = (
  lineItems: Partial<ILineItem>[],
): Partial<ILineItem>[] => {
  return (
    lineItems?.filter((item) => {
      const isReverseAllocation =
        item.description === LineItemDesciptionType.ReversedAllocation;
      const isAllocationItem = item.cost < 0 && isReverseAllocation;

      return !isReverseAllocation && !isAllocationItem;
    }) ?? []
  );
};
